const { find } = require('lodash');

class ManualAddressController {
    constructor($q, moveFocus, settings, addressService, deliveryFormControlState) {
        this.$q = $q;
        this.moveFocus = moveFocus;
        this.addressService = addressService;
        this.deliveryFormControlState = deliveryFormControlState;
        this.maxCharactersManualAddress1 = settings.oneSite.maxCharactersManualAddress1;
        this.maxCharactersManualAddress2 = settings.oneSite.maxCharactersManualAddress2;
    }

    get manualSearchButtonCaption() {
        return (this.isForExpress && this.manualAddressMode === 'SEARCH' && !this.isExpressUnavailable) ? 'Search now' : 'Shop now';
    }

    get shouldDisableShopButton() {
        return (!this.manualAddressForm.$valid && this.manualAddressMode === 'SEARCH') || this.isExpressUnavailable;
    }

    addressChange() {
        if (this.onAddressChange) {
            this.onAddressChange({ address: this.address });
        }
    }

    $onInit() {
        this.moveFocus('#manualAddress');
        if (!this.initialAddress) {
            this.clearInput();
        }
    }

    $onChanges(changes) {
        if (changes.initialAddress && this.initialAddress) {
            this.clearInput();
            this.useInitialAddress(this.initialAddress);
        }
    }

    clearInput() {
        this.address = {
            postcode: '', street1: '', street2: '', suburbId: null, suburb: '',
        };
        this.suburbs = [];
    }

    useInitialAddress(address) {
        this.address.postcode = address.postcode;
        this.loadSuburbs().then(() => {
            const initialSuburb = this.getInitialSuburb(address);
            this.address = {
                postcode: address.postcode,
                street1: address.street1,
                street2: address.street2,
                suburbId: initialSuburb.Id,
                suburb: initialSuburb.Text,
            };
            this.setSuburb({
                Id: initialSuburb.Id,
                Text: initialSuburb.Text,
            });
        });
    }

    getInitialSuburb(address) {
        return address.suburbId
            ? {
                Id: address.suburbId,
                Text: address.suburbName,
            }
            : this.getSuburbByName(address.suburbName);
    }

    getSuburbByName(suburbName) {
        return (suburbName && this.suburbs && this.suburbs.length)
            ? find(this.suburbs, item => item.Text.toLowerCase() === suburbName.toLowerCase())
            : { Id: '', Text: '' };
    }

    setSuburb(suburb) {
        if (suburb) {
            this.address.suburbId = !suburb.Id || suburb.Id === 'n/a' ? 0 : suburb.Id;
            this.address.suburb = suburb.Text;
            this.selectedSuburb = suburb;
            this.addressChange();
        }
        return this.selectedSuburb;
    }

    loadSuburbs() {
        if (this.address.postcode && this.address.postcode.length === 4) {
            return this.addressService.getSuburbs(this.address.postcode).then((suburbs) => {
                this.suburbs = suburbs;
                if (this.suburbs && this.suburbs.length) {
                    this.setSuburb(this.suburbs[0]);
                }

                this.addressChange();
            });
        } else if (this.address.postcode && this.address.postcode.length !== 4) {
            this.suburbs = null;
            this.address.suburb = null;
            this.addressChange();
        }
        return this.$q.reject();
    }

    onClickManualAddressForExpress() {
        if (this.isForExpress && this.manualAddressMode === 'SEARCH') {
            this.onValidateManualAddressForExpress();
        } else if (this.isForExpress && this.manualAddressMode === 'SHOP') {
            this.onShopManualAddressForExpress();
        }
    }

    onSubmit() {
        this.deliveryFormControlState.setChildFormSubmitting();
        this.onAddressSaved({ address: this.address });
    }
}

ManualAddressController.$inject = ['$q', 'MoveFocus', 'Settings', 'AddressService', 'DeliveryFormControlState'];

const manualAddressComponentDefinition = {
    transclude: {
        switchToSearch: '?switchToSearch',
    },
    bindings: {
        initialAddress: '<?',
        messageOnError: '@?',
        onAddressSaved: '&',
        onAddressChange: '&?',
        showSubmit: '<',
        manualAddressForm: '=?',
        isNewFulfilmentMethodSelector: '<?',

        // Express Delivery specific bindings.
        isForExpress: '<?',
        isExpressUnavailable: '<?',
        manualAddressMode: '@?',
        onValidateManualAddressForExpress: '&?',
        onShopManualAddressForExpress: '&?',
        isGrid: '<?',
    },
    controller: ManualAddressController,
    template: require('./manual-address.component.html').trim(),
};

module.exports = {
    ManualAddressController,
    manualAddressComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/address/manual-address.component.js